<template>
  <v-row no-gutters dense ref="menu" class="menu">
    <v-col cols="12" v-if="isMobile">
      <div class="close">
        <v-btn icon @click="closeDrawer">
          <v-icon color="primary">mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="logo">
        <div class="logo-text text-left">
          <router-link
            :to="{ name: 'HomeView', hash: '' }"
            class="primary--text"
          >
            <h2>Cinematic Celebration</h2>
          </router-link>
        </div>
      </div>
    </v-col>
    <v-col cols="12">
      <div class="menu-items secondary d-block d-lg-flex d-md-flex w-100">
        <div class="menu-text">
          <router-link
            exact
            :to="{ name: 'HomeView', hash: '#about-us' }"
            class="primary--text"
            >About Us
          </router-link>
        </div>

        <div class="menu-text">
          <router-link
            exact
            :to="{ name: 'HomeView', hash: '#our-space' }"
            class="primary--text"
            >Our Space
          </router-link>
        </div>

        <div class="menu-text d-none d-md-block">
          <router-link :to="{ name: 'HomeView' }" class="primary--text">
            <h2>Cinematic Celebration</h2>
          </router-link>
        </div>

        <div class="menu-text">
          <router-link
            exact
            :to="{ name: 'HomeView', hash: '#contact-us' }"
            class="primary--text"
            >Contact us
          </router-link>
        </div>

        <div class="menu-text">
          <router-link
            exact
            :to="{ name: 'BookOnline', params: { location: 'hulimavu' } }"
            class="primary--text"
            >Book Now
          </router-link>
          <!-- <router-link exact :to="{ name: 'BookNow' }" class="primary--text"
            >Book Now
          </router-link> -->
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AppMenu",
  data() {
    return {};
  },
  created() {},
  watch: {},
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    closeDrawer() {
      this.$emit("closeDrawer");
    },
  },
};
</script>
<style scoped>
.menu .menu-items {
  justify-content: center;
  align-items: center;
}

.menu .menu-text {
  text-align: left;
}

.menu .menu-text a {
  text-decoration: none;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  letter-spacing: normal;
}

.menu .menu-text a.router-link-exact-active {
  border-bottom: 4px solid;
}

.menu .menu-text + .menu-text {
  margin-left: 30px;
}

@media only screen and (max-width: 960px) {
  .menu {
    position: relative;
    padding: 80px 0 80px 30px;
  }

  .menu .close {
    position: absolute;
    top: 5%;
    left: 90%;
    transform: translate(-90%, -5%);
  }

  .menu .logo .logo-text {
    font-size: 20px;
    line-height: 22px;
    font-weight: 500;
    margin-bottom: 25px;
  }

  .menu .logo-text a {
    font-weight: 600;
    text-decoration: none;
  }

  .menu .menu-text + .menu-text {
    margin-left: 0;
    margin-top: 25px;
  }

  .menu .menu-text a {
    text-decoration: none;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    letter-spacing: normal;
  }
}
</style>
